export const Divider =() =>{
    return <div className="py-[3px] bg-[#FAFAFA] my-4"></div>
}